export { default as ContentWrap } from "./ContentWrap";
